import { useEffect, useState } from 'react';
import {
  FormControl,
  FormLabel,
  Select,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  useDisclosure,
  useToast,
  Spinner,
} from '@chakra-ui/react';
import { Company } from '../utils/types';
import { getCompanies, saveCompany } from '../hooks/companies';
import { useParams } from 'react-router-dom';

export default function CompanySelect({
  organizationId,
  onChange,
}: {
  organizationId: string;
  onChange: (value: string) => void;
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const { orgId } = useParams();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(false);
  const [newCompanyName, setNewCompanyName] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState<
    string | undefined
  >();

  const selectedCompany = companies.find((co) => co.id === selectedCompanyId);

  const [coFormData, setCoFormData] = useState({
    id: '',
    name: '',
    website: '',
    email: '',
    phone: '',
    address: '',
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) => {
    const { name, value } = e.target;
    setCoFormData((prev) => ({ ...prev, [name]: value }));
    console.log('coFormData:', coFormData);
  };
  // Fetch companies from backend
  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const res = await getCompanies(orgId);
      setCompanies(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast({
        title: 'Error fetching companies',
        status: 'error',
        duration: 3000,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    console.log(`${newCompanyName} ${selectedCompany} `);
    fetchCompanies();
  }, [orgId]);

  useEffect(() => {
    const setSelectedCoResult = async () => {
      if (selectedCompanyId && selectedCompanyId !== 'add_new') {
        onChange(selectedCompanyId);
      }
    };
    setSelectedCoResult();
  }, [selectedCompanyId]);

  const handleSelect = (value: string) => {
    if (value === 'add_new') {
      onOpen();
    } else {
      onChange(value);
    }
  };

  const handleAddCompany = async () => {
    try {
      await saveCompany(orgId || '', coFormData);
      toast({
        title: 'Company added',
        status: 'success',
        duration: 2000,
      });
      await fetchCompanies();
      onClose();
      setNewCompanyName('');
    } catch (err) {
      toast({
        title: 'Failed to add company',
        status: 'error',
        duration: 3000,
      });
    }
  };

  return (
    <>
      <FormControl mb={4}>
        <FormLabel>Related Company</FormLabel>
        {loading ? (
          <Spinner size="sm" />
        ) : (
          <Select
            placeholder="Select a company"
            value={selectedCompanyId || ''}
            onChange={(e) => {
              handleSelect(e.target.value);
              setSelectedCompanyId(e.target.value);
            }}
          >
            {companies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))}
            <option value="add_new">+ Add new company</option>
          </Select>
        )}
      </FormControl>

      {/* Add Company Modal */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New Company</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Enter company name"
              name="name"
              value={coFormData.name}
              onChange={handleChange}
            />
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleAddCompany}
              isDisabled={!coFormData.name.trim()}
            >
              Save
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
